module.exports = __webpack_public_path__ + "static/datapoint-35910af338f4f01aa760ed3b523c2263.jpg";